import {UseQueryResult} from '@tanstack/react-query';

export interface ApiResponseError {
  error_code: string;
  error_message: string;
  extra_details: string;
  [key: string]: any;
}

export interface ApiResponse<T> {
  ok: boolean;
  data: T | undefined;
  error: ApiResponseError | undefined;
}

export type UseQueryResponse<T> = Pick<UseQueryResult<T>, 'isLoading' | 'data' | 'error' | 'refetch' | 'isPending'>;

export const isApiResponseError = (data: any): data is ApiResponseError => {
  return !!data?.error_code;
};
